import React, { useState } from 'react';
import { Container } from "react-bootstrap";
import { useData } from '../../context/DataContext';
import Loading from '../Loading/Loading';
import MaterialReactTableWithSearch from '../MaterialTable/MaterialReactTableWithSearch';

function ContactSupport() {
    const { contactedData, loading, error, todayContacted } = useData();
    const [activeFilter, setActiveFilter] = useState('total');

    if (loading) return <Loading />;
    if (error) return <div style={{ padding: 24, color: 'red' }}>Error: {error}</div>;
    if (!contactedData) return <div style={{ padding: 24 }}>No contact data available.</div>;

    const columns = [
        { accessorFn: (row, index) => index + 1, header: 'SNO', id: 'id', size: 60 },
        { accessorKey: 'name', header: 'Name' },
        { accessorKey: 'email', header: 'Email' },
        { accessorKey: 'message', header: 'Message' },
        {
            accessorKey: 'inserted_time', header: 'Date',
            Cell: ({ cell }) => {
                const d = new Date(cell.getValue());
                return <span>{d.toLocaleString('en-US', { year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', hour12: true }).replace(',', '')}</span>;
            },
        },
    ];

    const activeData = activeFilter === 'total' ? contactedData : todayContacted;

    return (
        <Container fluid className="px-0">
            <div className="page-header">
                <div>
                    <h1 className="page-title">Contact Support</h1>
                    <p className="page-subtitle">{contactedData.length} support tickets total</p>
                </div>
            </div>

            <div className="filter-bar">
                <button
                    className={`btn-filter ${activeFilter === 'total' ? 'active' : ''}`}
                    onClick={() => setActiveFilter('total')}
                >
                    All Tickets
                    <span className="stats-chip" style={{ marginLeft: 8 }}>{contactedData.length}</span>
                </button>
                <button
                    className={`btn-filter ${activeFilter === 'today' ? 'active' : ''}`}
                    onClick={() => setActiveFilter('today')}
                >
                    Today
                    <span className="stats-chip" style={{ marginLeft: 8 }}>{todayContacted.length}</span>
                </button>
            </div>

            <div className="table-container">
                <MaterialReactTableWithSearch columns={columns} data={activeData} />
            </div>
        </Container>
    );
}

export default ContactSupport;
